import React from 'react';
import { componentService } from 'js/services/component.service';

export const Kambi = React.lazy(() => import(/* webpackChunkName: "kambi" */ './Kambi'));

componentService.registerPageComponents({ kambi: Kambi });
